import { type FunctionComponent } from 'react';
import * as React from 'react';
import classnames from 'classnames';

import styles from './main.scss';
import dibsCss from 'dibs-css';

type ModalBodyProps = {
    className?: string;
    children?: React.ReactNode;
    topSpacing?: 'small' | 'medium' | 'large' | 'none';
    horizontalPadding?: 'mediumPadding' | 'noPadding';
};

export const ModalBody: FunctionComponent<ModalBodyProps> = props => {
    const { className, children, topSpacing = 'large', horizontalPadding } = props;

    return (
        <div
            className={classnames(
                styles.modalBody,
                {
                    [dibsCss.mtLarge]: topSpacing === 'large',
                    [dibsCss.mtMedium]: topSpacing === 'medium',
                    [dibsCss.mtSmall]: topSpacing === 'small',
                    [styles.mediumPadding]: horizontalPadding === 'mediumPadding',
                    [styles.noPadding]: horizontalPadding === 'noPadding',
                },
                className
            )}
            data-tn="modal-body"
        >
            {children}
        </div>
    );
};
